import * as React from 'react';

type Props = {
    value: string | string[] | null | undefined;
};

export function Enum(props: Props) {
    if (!props.value || !props.value.length) {
        return null;
    }

    const displayValue = Array.isArray(props.value) ? props.value.join(', ') : props.value;

    return <>{displayValue}</>;
}
